module.exports = __webpack_public_path__ + "static/logo-219863b0a049a20db7dd1ae52aef028d.png";